import { PureComponent } from "react";
import { func, number } from "prop-types";

import { RECAPTCHA_SITE_KEY } from "../../constants";

class Recaptcha extends PureComponent {
  constructor(props) {
    super(props);

    this.handleCallback = this.handleCallback.bind(this);
    this.load = this.load.bind(this);

    this._isMounted = false;
    this.callbackName = "reCaptchaCallback";
  }

  /**
   * Handle reCaptcha's onload callback
   * @public
   */
  handleCallback() {
    this.props.handleRecaptchaLoaded();
  }

  /**
   * Load reCaptcha
   * @public
   */
  load() {
    const { recaptchaLoading, recaptchaLoaded } = this.props;
    if (this._isMounted && !recaptchaLoading && !recaptchaLoaded) {
      this.props.handleRecaptchaLoading();

      const { callbackName } = this;
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}&onload=${callbackName}`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }

  componentDidMount() {
    this._isMounted = true;
    window[this.callbackName] = this.handleCallback;

    this._timeout = setTimeout(this.load, this.props.delay);
  }

  componentWillUnmount() {
    this._isMounted = false;
    delete window[this.callbackName];

    if (!!this._timeout) {
      clearTimeout(this._timeout);
    }
  }

  render() {
    return null;
  }
}

Recaptcha.propTypes = {
  delay: number,
  handleRecaptchaLoaded: func.isRequired,
  handleRecaptchaLoading: func.isRequired,
};

Recaptcha.defaultProps = {
  delay: 0,
};

export default Recaptcha;
